import {
  UPDATE_FAVOURITE,
  REMOVE_FAVOURITE_ITEM,
  CLEAR_FAVOURITE,
  LOAD_FAVOURITE_DATA,
  SET_FAVOURITE_STATUS,
  SET_ADD_REMOVE_FAVOURITE_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  favouriteItems: [],
  isLoading: false,
  failText: '',
  isFavourateIconLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_FAVOURITE:
      return { ...state, favouriteItems: action.payload };
    case REMOVE_FAVOURITE_ITEM:
      return {
        ...state,
        favouriteItems: state.favouriteItems.filter(item => item.Material !== action.payload),
      };
    case CLEAR_FAVOURITE:
      return { ...state, favouriteItems: [] };
    case LOAD_FAVOURITE_DATA:
      return {
        ...state,
        favouriteItems: action.payload.list,
        isLoading: false,
      };
    case SET_FAVOURITE_STATUS:
      return { ...state, ...action.payload };
    case SET_ADD_REMOVE_FAVOURITE_STATUS:
      return {
        ...state,
        isFavourateIconLoading: action.payload,
      };
    default:
      return state;
  }
};
